import TextField from '@mui/material/TextField'
import { Text } from '../1elements'
import Box from '@mui/material/Box'

const MapZoomNumberField = ({
  value,
  setValue,
  max,
  min,
  disabled,
  onChange
}) => {
  const handleChange = (e) => {
    const zoomValue = Number(e.target.value)

    if (max && zoomValue > max) setValue(max)
    if (zoomValue < min) setValue(min)
    else setValue(zoomValue)
  }

  return (
    <Box sx={{ maxWidth: '400px', minWidth: 150, position: 'relative' }}>
      <Text type={'h9'} style={{ position: 'absolute', top: -20 }}>
        Zoom Level
      </Text>
      <TextField
        sx={fieldSx}
        disabled={disabled}
        value={value}
        max={max}
        min={min}
        variant="outlined"
        type="number"
        onChange={handleChange}
      />
    </Box>
  )
}

export default MapZoomNumberField

const fieldSx = theme => ({
    backgroundColor: theme.palette.quaternary.main,
    '& .MuiTextField-root': {
      marginTop: 0,
      width: '100%'
    },
    '& .MuiInputBase-input': {
      width: '100%',
      padding: '5px 13px',
      boxShadow: 'none',
      '&:focus': {
        boxShadow: `${theme.boxShadow} !important`
      },
      '&:hover': {
        boxShadow: `${theme.boxShadow} !important`
      }
    },
    '& .MuiInputBase-multiline': {
      padding: 0
    },
    '& .MuiOutlinedInput-root': {
      border: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main
    },
    '& fieldset': {
      border: 'none'
    }
})
